/* @flow */
export const COLOR_LABEL_TYPE = 'color';

export const colorClassName =
  (name: string, label: string): string =>
    name && label === COLOR_LABEL_TYPE
      ? `${name.toLowerCase()} hex-map`
      : '';
